import { withTranslation } from "next-i18next";
import sizeTypes from "@utils/constants/sizeTypes";

function SizeReferenceLabel({ t, product, selectedVariant }) {
  let text = "";

  if (!product.variants.some(variant => variant.available) && !selectedVariant) {
    text = "";
  } else if (product.size_type === sizeTypes.size_tu) {
    text = "";
  } else if (!selectedVariant) {
    text = "";
  } else if (product.size_type === sizeTypes.size_multiple) {
    const [firstSize, lastSize] = product.variants[0].size.value.split("~");

    text = t("product:size_reference_label.fits_from_to", { firstSize, lastSize });
  } else if ([sizeTypes.size_int, sizeTypes.size_double].includes(product.size_type)) {
    text = t(`product:size_reference_label.size_to_international_converter.${product.size_type}.${selectedVariant}`);
  } else {
    text = t("product:size_reference_label.equivalent_to_a_size", {
      size: t(`product:size_reference_label.size_to_international_converter.${product.size_type}.${selectedVariant}`),
    });
  }

  return (
    <div className="d-flex align-items-center">
      <p className="font-weight-bold">
        {t("product:size_reference_label.title")}
        &nbsp;
        <span className="font-weight-normal text-gray">
          {text}
        </span>
      </p>
    </div>
  )
};

export default withTranslation("product")(SizeReferenceLabel);